import * as React from "react";
import { Card, Form } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { BillingAccountAlert } from "../../schema/types/account";
import { CpSwitch } from "../gvc/testNewForm/CpSwitch";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../gvc/testNewForm/CpInput";

interface Props {
  alert: BillingAccountAlert;
}
export const Alert: React.FC<Props> = ({ alert }) => {
  return (
    <>
      <Form.Item name={["meta", "alert", "isReadonly"]} noStyle />
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Monthly Spend Alert</CardTitle>
          <CardContent>
            <CpFormItem>
              <div className="flex items-center gap-2">
                <CpLabel name={`alert.enabled`}>Enabled</CpLabel>
                <CpSwitch name={`alert.enabled`} />
              </div>
              <CpErrorWarning name={`alert.enabled`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`alert.amount`}>Amount (USD)</CpLabel>
              <CpInput name={`alert.amount`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`alert.amount`} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
